import clsx from 'clsx';
import React, { ReactElement, useState } from 'react';
import { Popover } from '../../../ui/popover/Popover';

interface AnnualDeviceTableCellProps {
  value: string;
  error?: string;
  warning?: string;
  edited?: boolean;
  disabled?: boolean;
  handleChange: (value: string) => void;
}

export function AnnualDeviceTableCell({
  value,
  error,
  warning,
  edited,
  disabled,
  handleChange,
}: Readonly<AnnualDeviceTableCellProps>): ReactElement<AnnualDeviceTableCellProps> {
  const [inputRef, setInputRef] = useState<HTMLInputElement | null>();

  return (
    <td className="group/cell relative p-0">
      <div
        className={clsx(
          'relative box-border border-0 border-b border-l border-solid border-grey-200 text-center outline-2 -outline-offset-1',
          error ? 'z-10 outline outline-error-500' : 'focus-within:z-20 focus-within:outline',
          {
            'bg-error-50/25': error && edited,
            'bg-warning/[15%]': !error && warning && edited,
            'bg-green-50/50': !error && !warning && edited,
            'focus-within:outline-warning': !error && warning,
            'focus-within:outline-green-200': !error && !warning,
          },
        )}
      >
        <input
          ref={(ref) => setInputRef(ref)}
          className="box-border w-full border-none bg-transparent p-5 text-center text-sm leading-4 focus:outline-none"
          disabled={disabled}
          value={value}
          onFocus={(event) => event.target.select()}
          onChange={(event) => handleChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') {
              inputRef?.blur();
              event.preventDefault();
            }
          }}
        />
      </div>
      {(error || warning) && <Popover baseElement={inputRef} error={error} warning={warning} />}
    </td>
  );
}
